import { cva } from 'class-variance-authority';

export const statusIconColors = {
  draft: 'text-accent-amber',
  for_action: 'text-accent-pink',
  reviewed: 'text-accent-blue',
  approved: 'text-accent-lime',
  sent: 'text-accent-purple',
  empty: 'text-text-tertiary',
};

const statusTextColors = {
  draft: 'text-accent-amber hover:text-accent-amber aria-expanded:text-accent-amber',
  for_action: 'text-accent-pink hover:text-accent-pink aria-expanded:text-accent-pink',
  reviewed: 'text-accent-blue hover:text-accent-blue aria-expanded:text-accent-blue',
  approved: 'text-accent-lime hover:text-accent-lime aria-expanded:text-accent-lime',
  sent: 'text-accent-purple hover:text-accent-purple aria-expanded:text-accent-purple',
  empty: 'text-text-secondary group-hover:text-text-primary',
};

/** Filled chip styling for Action Center table: rounded-md, light bg + accent text, 12px medium */
export const statusChipVariants = cva(
  'rounded-md px-2 py-1 text-center font-body text-xs font-medium leading-[100%]',
  {
    variants: {
      variant: {
        empty: 'bg-background-secondary text-text-secondary',
        draft: 'bg-validation-warning-muted text-validation-warning',
        for_action: 'bg-entity-pink-muted text-entity-pink-foreground',
        reviewed: 'bg-validation-info-muted text-validation-info',
        approved: 'bg-validation-success-muted text-validation-success',
        sent: 'bg-entity-purple-muted text-entity-purple-foreground',
      },
    },
    defaultVariants: {
      variant: 'empty',
    },
  }
);

export const statusIconVariants = cva(null, {
  variants: {
    variant: {
      ...statusIconColors,
    },
  },
  defaultVariants: {
    variant: 'empty',
  },
});

export const statusTextVariants = cva('', {
  variants: {
    variant: {
      ...statusTextColors,
    },
  },
  defaultVariants: {
    variant: 'empty',
  },
});
